import actionCreators from 'actionCreators';
import {getAppSettings, getSettings} from 'api/SettingsApi';

const RESET = 'pulp/settings/RESET';
const UPDATE = 'pulp/settings/UPDATE';

export const initialState = {};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case RESET:
      return action.payload;
    case UPDATE:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}

export function resetSettings(payload) {
  return {type: RESET, payload};
}

export function updateSettings(payload) {
  return {type: UPDATE, payload};
}

export function loadSettings() {
  return async dispatch => {
    const {data: settingsData} = await getSettings();
    const {data: appConfigsData} = await getAppSettings();

    const promises = [];
    promises.push(dispatch(resetSettings(settingsData)));
    promises.push(dispatch(actionCreators.initializeGateways()));
    promises.push(dispatch(updateSettings(appConfigsData)));

    return Promise.all(promises);
  };
}
